// SON — "Nos suggestions" : chargement + carrousel.
// On charge nous-memes les recommandations (limit=10, le max de l'API Shopify)
// pour ne pas dependre du loader de theme.js (fige a 4). Puis on initialise un
// carrousel slick sur TOUTES les largeurs (desktop inclus).
function sonInitRecoCarousel() {
  var sliderContainer = $('.recommendations-container').first();
  if (!sliderContainer.length || sliderContainer.hasClass('slick-initialized')) { return; }

  var leftArrow = $('#recommendations-carousel-left');
  var rightArrow = $('#recommendations-carousel-right');

  sliderContainer.slick({
    arrows: false,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3 } },
      { breakpoint: 992,  settings: { slidesToShow: 2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1.2 } }
    ]
  });

  function refreshArrows(current) {
    var shown = sliderContainer.slick('slickGetOption', 'slidesToShow') || 1;
    var count = sliderContainer.slick('getSlick').slideCount;
    leftArrow.toggleClass('disabled', current <= 0);
    rightArrow.toggleClass('disabled', current >= count - shown);
  }

  refreshArrows(0);
  sliderContainer.on('afterChange', function(_, slick, current) { refreshArrows(current); });
  leftArrow.on('click', function() { sliderContainer.slick('slickPrev'); });
  rightArrow.on('click', function() { sliderContainer.slick('slickNext'); });
}

function sonLoadRecommendations() {
  // Si le contenu est deja rendu (cas performed=true renvoye directement), on
  // initialise simplement le carrousel.
  if ($('.recommendations-container').length) { sonInitRecoCarousel(); return; }

  var loader = document.querySelector('.son-reco-loader');
  if (!loader) { return; }
  var baseUrl = loader.getAttribute('data-base-url');
  var productId = loader.getAttribute('data-product-id');
  if (!baseUrl || !productId) { return; }

  var url = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=10&intent=related';
  $.get(url).then(function(section) {
    // DOMParser : n'execute pas les scripts de la reponse.
    var doc = new DOMParser().parseFromString(section, 'text/html');
    var inner = doc.querySelector('.product-recommendations__inner');
    if (inner) {
      loader.replaceWith(inner);
      sonInitRecoCarousel();
    } else {
      loader.remove();
    }
  });
}

$('document').ready(sonLoadRecommendations);
